module.exports = __webpack_public_path__ + "static/fonts/Roboto-Medium.894a2ed.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/roboto/Roboto-Medium.ttf
// module id = 316
// module chunks = 1